import * as preact from 'preact'
const { h, Component } = preact
import PureComponent from '../../lib/preact-pure-component'
import { ShowSourceButton } from './show-source-button'
import { Modal } from './modal'
import { Source as SourceType } from '../types'
import { connect } from '../../../lib/provider'

interface Props {
  activeSection?: any
  sources?: SourceType[]
  activeSourceButtonID?: string
}

interface ConnectedProps {
  sendGaEvent: (evt: Object) => void
}

interface State {
  open: boolean
}

class _Source extends PureComponent<ConnectedProps & Props, State> {
  constructor() {
    super()
    this.state = {
      open: false
    }
  }

  open = () => {
    this.props.sendGaEvent({ action: 'open modal', label: this.getActiveSectionSourceId() })
    this.setState({ open: true })
  }

  close = () => {
    this.setState({ open: false })
  }

  activeSectionContainsSource = () => {
    if (this.props.activeSection) {
      const { activeSection } = this.props
      let containsSource = false
      activeSection.blocks.forEach((block: any) => {
        if (!!block.source) {
          containsSource = true
        }
      })
      return containsSource
    }
  }

  getActiveSectionSourceId = () => {
    return this.props.activeSection.blocks.find(block => !!block.source).source
  }

  getModalContent = () => {
    if (this.props.sources) {
      const activeSectionSourceId = this.getActiveSectionSourceId()
      return this.props.sources.find(source => source.id === activeSectionSourceId)
    }
  }

  getIdx = () => {
    if (this.props.sources) {
      const activeSectionSourceId = this.getActiveSectionSourceId()
      return this.props.sources.findIndex(source => source.id === activeSectionSourceId)
    }
  }

  render() {
    if (this.activeSectionContainsSource()) {
      const { activeSection, activeSourceButtonID } = this.props
      const active = activeSection.id === activeSourceButtonID

      const content = this.getModalContent()
      return (
        <div aria-hidden="true">
          <ShowSourceButton onClick={this.open} active={active} />
          <Modal idx={this.getIdx()} isOpen={this.state.open} close={this.close} content={content} />
        </div>
      )
    }
    return null
  }
}

const connector = connect()
export const Source = connector(_Source)
